import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'
import { makeDataUrl } from '../utils'

export default
class FileItem
  extends Component {

  static defaultProps = {
    renderChildren: () => { }
  }

  static propTypes = {
    all: PropTypes.array,
    descriptionPlaceholder: PropTypes.string,
    disabled: PropTypes.bool,
    index: PropTypes.number,
    item: PropTypes.object,
    onChange: PropTypes.func,
    onRemove: PropTypes.func,
    renderChildren: PropTypes.func,
    value: PropTypes.string,
  }

  getItemDescription(item) {
    if (item.description) {
      return item.description
    }
    return item.pivot ? item.pivot.description : ''
  }

  @autobind
  handleRemove() {
    if (this.props.onRemove) {
      this.props.onRemove({
        target: {
          index: this.props.index
        }
      })
    }
  }

  @autobind
  handleChange(e) {
    if (e.type === 'file' && e.preventDefault) {
      e.preventDefault()
    }
    if (e.stopPropagation) {
      e.stopPropagation()
    }
    const {
      target: {
        name, value, type, checked
      }
    } = e
    if (this.props.onChange) {
      this.props.onChange({
        target: {
          index: this.props.index,
          data: {
            // eslint-disable-next-line
            [name]: type === 'checkbox'
              ? (checked ? (value || true) : 'image')
              : value
          }
        }
      })
    }
  }

  render() {
    const {
      all,
      index,
      item,
      descriptionPlaceholder,
      renderChildren,
      disabled
    } = this.props
    return (
      <li
        onChange={this.handleChange}
      >
        <input
          type="hidden"
          name="id"
          value={item.id}
        />
        <input
          type="hidden"
          name="url"
          value={item.url}
        />
        <input
          type="hidden"
          name="name"
          value={item.name}
        />
        <div className="tools pull-right">
          <a className="btn btn-link action"
            onClick={this.handleRemove}
          >
            <i className="glyphicon glyphicon-trash" />
          </a>
        </div>
        {(item.url || item.dataURL)
          ? (
            <div
              className="thumbnail"
              style={{
                backgroundImage: `url(${item.url ? makeDataUrl(item) : item.dataURL})`
              }}
            />
          )
          : null}
        <div
          className="file-name"
          title={item.name}
        >
          {item.url
            ? (
              <a
                href={makeDataUrl(item)}
                target="_blank"
                rel="noopener noreferrer"
              >
                {item.name}
              </a>
            )
            : item.name}
        </div>
        <div className="form-group">
          <label
            className="form-control hidden"
            htmlFor={`${item.name}-${index}-description`}
          />
          <textarea
            rows="2"
            placeholder={descriptionPlaceholder}
            className="form-control"
            id={`${item.name}-${index}-description`}
            name="description"
            value={this.getItemDescription(item)}
            autoFocus
            disabled={disabled}
          />
        </div>
        {renderChildren(all, index, item, disabled, this.handleChange)}
      </li>
    )
  }

}



// WEBPACK FOOTER //
// ./src/shared/components/FileItem.js